<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ModrAddMain from "@/views/PurchaseManagement/ModrManage/TabChild/ModrAddMain";

export default {
  name: "ModrAdd",
  components: {
    childTab1: ModrAddMain
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>